/* eslint-disable */

export enum ComplianceState {
  /** NEW - Carry payments for new customers. */
  NEW = "NEW",
  /**
   * FORCE_UPGRADE - If either customer is in this state when a payment is created,
   * that customer is required to upgrade to complete the
   * payment.
   *
   * We should explode if risk attempts to approve a payment
   * while either customer is in this state. Ie. payments should
   * not advance from WAITING_ON_RISK to PAYING_OUT
   * while either customer is in this state.
   *
   * Special case: it's possible that a customer was put in this
   * state after the payment was created, and no upgrade was
   * requested. In that case we should advance the payment,
   * otherwise it would be stuck.
   */
  FORCE_UPGRADE = "FORCE_UPGRADE",
  /** APPROVED - Carry payments for approved customers. */
  APPROVED = "APPROVED",
  /** BLACKLISTED - Permanently hold payments for denylisted customers. */
  BLACKLISTED = "BLACKLISTED",
}
